import React from 'react';

interface FullScreenLoaderProps {
  title?: string;
  message?: string;
  showProgress?: boolean;
  iconType?: 'spinner' | 'printer' | 'copy';
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  title = "Cargando",
  message = "Por favor espere un momento...",
  showProgress = true,
  iconType = 'spinner'
}) => {
  return (
    <div className="page-content bg-white d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
      <div className="text-center p-5">
        <div className="mb-4">
          <div className="widget-icon-loader">
            {iconType === 'printer' && (
              <i className="bx bx-printer bx-tada" style={{ fontSize: '4rem', color: '#0ab39c' }}></i>
            )}
            {iconType === 'copy' && (
              <i className="bx bx-copy bx-burst" style={{ fontSize: '4rem', color: '#0ab39c' }}></i>
            )}
          </div>
        </div>
        <h4 className="fw-semibold text-dark mb-2">{title}</h4>
        <p className="text-muted fs-15 mx-auto" style={{ maxWidth: '400px' }}>
          {message}
        </p>
        {showProgress && (
          <div className="mt-4 pt-2">
            <div className="progress animated-progress progress-sm" style={{ width: '200px', margin: '0 auto' }}>
              <div
                className="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{ width: '100%' }}
                aria-valuenow={100}
                aria-valuemin={0}
                aria-valuemax={100}
              ></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FullScreenLoader;
